// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 768px) {
  .react-modal-overlay.confirm-disconnect-modal .react-modal {
    padding-top: 1rem;
    top: 15%;
    left: calc(50% - 16rem);
    width: 32rem;
    height: 35rem;
    height: -moz-fit-content;
    height: fit-content;
    box-shadow: 0.3rem 0.5rem 0.5rem 0 rgba(0, 0, 0, 0.19);
    border-radius: 0.5rem;
  }
}
.react-modal-overlay.confirm-disconnect-modal .logo-wrapper {
  text-align: center;
}
.react-modal-overlay.confirm-disconnect-modal .logo-wrapper img.logo {
  height: 5rem;
  margin-bottom: 2rem;
  margin-top: 2rem;
}
@media (min-width: 768px) {
  .react-modal-overlay.confirm-disconnect-modal .logo-wrapper {
    display: none;
  }
}
.react-modal-overlay.confirm-disconnect-modal h1 {
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 1rem;
}
.react-modal-overlay.confirm-disconnect-modal .actions {
  display: flex;
  justify-content: space-around;
  margin-top: 2rem;
}
.react-modal-overlay.confirm-disconnect-modal .actions button {
  border: none;
  cursor: pointer;
  width: 10rem;
}`, "",{"version":3,"sources":["webpack://./src/Components/ConfirmDisconnectAccount/ConfirmDisconnectAccount.scss"],"names":[],"mappings":"AAII;EADF;IAEI,iBAAA;IACA,QAAA;IACA,uBAAA;IACA,YAAA;IACA,aAAA;IACA,wBAAA;IAAA,mBAAA;IAGA,sDAAA;IACA,qBAAA;EAFJ;AACF;AAKE;EACE,kBAAA;AAHJ;AAII;EACE,YAAA;EACA,mBAAA;EACA,gBAAA;AAFN;AAKI;EARF;IASI,aAAA;EAFJ;AACF;AAKE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AAHJ;AAME;EACE,aAAA;EACA,6BAAA;EACA,gBAAA;AAJJ;AAKI;EACE,YAAA;EACA,eAAA;EACA,YAAA;AAHN","sourcesContent":["@import 'Variables.scss';\n\n.react-modal-overlay.confirm-disconnect-modal {\n  .react-modal {\n    @media (min-width: $tablet) {\n      padding-top: 1rem;\n      top: 15%;\n      left: calc(50% - 16rem);\n      width: 32rem;\n      height: 35rem;\n      height: fit-content;\n      -webkit-box-shadow: 0.3rem 0.5rem 0.5rem 0 rgba(0, 0, 0, 0.19);\n      -moz-box-shadow: 0.3rem 0.5rem 0.5rem 0 rgba(0, 0, 0, 0.19);\n      box-shadow: 0.3rem 0.5rem 0.5rem 0 rgba(0, 0, 0, 0.19);\n      border-radius: 0.5rem;\n    }\n  }\n\n  .logo-wrapper {\n    text-align: center;\n    img.logo {\n      height: 5rem;\n      margin-bottom: 2rem;\n      margin-top: 2rem;\n    }\n\n    @media (min-width: $tablet) {\n      display: none;\n    }\n  }\n\n  h1 {\n    font-size: 2rem;\n    font-weight: 600;\n    margin-bottom: 1rem;\n  }\n\n  .actions {\n    display: flex;\n    justify-content: space-around;\n    margin-top: 2rem;\n    button {\n      border: none;\n      cursor: pointer;\n      width: 10rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
